import axiosInstance from "@/api/axios-instance";
import { UnmappedSessionsResponse } from "@/pages/audit/types/unmapped-sessions";

export interface UnmappedSessionParams {
  page: number;
  limit?: number;
  search?: string;
  exclude?: string;
  date_from?: string;
  date_to?: string;
}

export async function getUnmappedSessions(
  params: UnmappedSessionParams
): Promise<UnmappedSessionsResponse> {
  const response = await axiosInstance.get("/audit/unmapped-sessions", {
    params: { limit: 10, ...params },
  });
  return response.data;
}
